import * as React from 'react';
import { ComponentProps } from 'react';

import { Box } from '@mui/material';
import { ndBlueDarkest } from '@utils/colorGenerator';
import SearchLink from './SearchLink';
import UserDropdown from './UserDropdown';
import { HelpModalOpener } from './help/HelpModal';

const iconButtonStyles: ComponentProps<typeof Box>['sx'] = {
  marginLeft: 3,
  border: `2px solid ${ndBlueDarkest}`,
  color: ndBlueDarkest,
  width: '50px',
  height: '50px',
  fontSize: '1.2rem',
  alignItems: 'center',
};

type NavLinksProps = {
  downloadButton?: React.ReactElement;
  onHelpModalToggle: () => void;
};

const NavLinks = React.memo((props: NavLinksProps) => {
  return (
    <>
      <Box sx={{ ml: 'auto', display: 'flex', alignItems: 'center' }}>
        <HelpModalOpener
          sx={iconButtonStyles}
          openModal={props.onHelpModalToggle}
        />
        <SearchLink iconOnly sx={iconButtonStyles} />
        {props.downloadButton}
        <UserDropdown
          sx={iconButtonStyles}
          handleHelpModal={props.onHelpModalToggle}
        />
      </Box>
    </>
  );
});

NavLinks.displayName = 'NavLinks';

export default NavLinks;
